import { makeAutoObservable } from "mobx";
import { LoaderShelf } from "../../../shelves";
import { api } from "../../../services";
import type { AuthenticationStore, FintechRegisterStore, ValidationOTPStore } from "../../../stores";
import type { PersonalContactEmailInfo } from "../../../services/APIService/types";
import type { AxiosError } from "axios";

export enum StatusRequestPersonalContactsEmails {
	LOAD = "LOAD",
	SUCCESS = "SUCCESS",
	ERROR = "ERROR",
}

export class Store {
	public loader = new LoaderShelf();

	constructor(
		public authentication: AuthenticationStore,
		public fintechRegisterStore: FintechRegisterStore,
		public validationOTPStore: ValidationOTPStore,
	) {
		makeAutoObservable(this);
	}

	public fetchEmail = async (): Promise<StatusRequestPersonalContactsEmails> => {
		if (this.loader.isLoading) {
			return StatusRequestPersonalContactsEmails.LOAD;
		}

		this.loader.start();

		try {
			const body: PersonalContactEmailInfo = {
				email: this.fintechRegisterStore.getNewEmail || this.fintechRegisterStore.email.field.value,
				isMain: true,
			};

			const emailId = this.fintechRegisterStore.idEmail.value || "";
			const validationId = this.validationOTPStore.getValidationId;

			if (this.fintechRegisterStore.hasAlreadyPersonalContactsEmailRegistered.value) {
				await api.patchCustomersPersonalContactsEmails(body, validationId, emailId, this.authentication.getToken() || "");
			} else {
				await api.postCustomersPersonalContactsEmails(body, validationId, this.authentication.getToken() || "");
			}

			return StatusRequestPersonalContactsEmails.SUCCESS;
		} catch (e) {
			window.console.error(e);
			const error = e as AxiosError;

			// se o email já estiver cadastrado com outro CPF vai dar conflito e não deve ser tratado como erro
			if (error.response?.status === 409) {
				return StatusRequestPersonalContactsEmails.SUCCESS;
			}

			return StatusRequestPersonalContactsEmails.ERROR;
		} finally {
			this.loader.end();
		}
	};
}
